module.exports = __webpack_public_path__ + "img/video.4afd991b.svg";